import React from "react";
import {OsmosisEmptyLogo} from "./empty-logo";

import style from "./style.module.css"

export const OsmosisIcon = () => {
    return <div className={`${style.osmosisIcon} ${style.animated}`}><OsmosisEmptyLogo /></div>
}

